import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=24ea749f&"
import script from "./CustomToast.vue?vue&type=script&lang=js&"
export * from "./CustomToast.vue?vue&type=script&lang=js&"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=24ea749f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports